import { render, staticRenderFns } from "./DocumentGeneral.vue?vue&type=template&id=1a1ae97a&"
import script from "./DocumentGeneral.vue?vue&type=script&lang=js&"
export * from "./DocumentGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports